import sidepane from "./sidepane.vue"

const Sidepane = {
  install(Vue) {
    Vue.component("sidepane", sidepane)
    Vue.prototype.$sidepane = async function(title, detail, data, options) {
      try {
        const $options = {
          position: "left",
          select: "single"
        }

        if (["left", "right"].indexOf(options) > -1) $options.position = options
        if (typeof options === "object") Object.assign($options, options)
        if (!Array.isArray(data)) return false

        if (data.length && typeof data[0] !== "object") {
          data = data.map(item => {
            return { key: item, value: item }
          })
        }

        const promise = await _$.progress.create()

        const $package = {
          title: title,
          detail: detail,
          data: data,
          options: $options,
          resolve: e => {
            promise.resolve(e)
          },
          reject: e => {
            promise.reject(e)
          }
        }

        _$.vue.$emit("sidepane", $package)

        return promise.done
      } catch (err) {
        return _$.error(err)
      }
    }
  }
}

export default Sidepane
